(function () {
  'use strict';

  // ── Shopify Forms injection ──────────────────────────────────────────────

  var FORM_ID_ATTR = 'forms-root-1023670';

  var SHADOW_CSS = `
    section:has(> h2) {
      display: none !important;
    }
    input {
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 100% !important;
      box-sizing: border-box !important;
      padding: var(--input-padding-block, .65rem) var(--input-padding-inline, 1rem) !important;
      border: 1px solid rgb(var(--input-text-color, var(--text-color, 0 0 0)) / .15) !important;
      border-radius: var(--input-border-radius, 0px) !important;
      background: rgb(var(--input-background, transparent)) !important;
      color: rgb(var(--input-text-color, var(--text-color, 0 0 0))) !important;
      font: inherit !important;
      outline: none !important;
      box-shadow: none !important;
      transition: border-color .2s, padding-block .15s ease-in-out !important;
      z-index: 1 !important;
    }
    textarea {
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 100% !important;
      box-sizing: border-box !important;
      padding: var(--input-padding-block, .65rem) var(--input-padding-inline, 1rem) !important;
      border: 1px solid rgb(var(--input-text-color, var(--text-color, 0 0 0)) / .15) !important;
      border-radius: min(12px, 1.875rem) !important;
      background: rgb(var(--input-background, transparent)) !important;
      color: rgb(var(--input-text-color, var(--text-color, 0 0 0))) !important;
      font: inherit !important;
      outline: none !important;
      box-shadow: none !important;
      transition: border-color .2s, padding-block .15s ease-in-out !important;
      z-index: 1 !important;
    }
    input:focus, textarea:focus {
      border-color: currentColor !important;
      outline: none !important;
      box-shadow: none !important;
    }
    input:focus, input:not(:placeholder-shown) {
      padding-block-start: calc(1.6 * var(--input-padding-block, .65rem)) !important;
      padding-block-end: calc(0.4 * var(--input-padding-block, .65rem)) !important;
    }
    label {
      position: absolute !important;
      top: 0 !important;
      left: var(--input-padding-inline, 1rem) !important;
      height: 100% !important;
      display: flex !important;
      align-items: center !important;
      transform-origin: left top !important;
      pointer-events: none !important;
      transition: transform .15s ease-in-out, opacity .15s ease-in-out !important;
      color: inherit !important;
      opacity: .7 !important;
    }
    input:focus + label, input:not(:placeholder-shown) + label {
      transform: scale(.65) translateY(calc(-.4 * var(--input-padding-block, .65rem))) !important;
      opacity: 1 !important;
    }
    textarea + label {
      height: auto !important;
      top: var(--input-padding-block, .65rem) !important;
      align-items: flex-start !important;
    }
    textarea:focus {
      padding-block-start: calc(1.6 * var(--input-padding-block, .65rem)) !important;
      padding-block-end: calc(0.4 * var(--input-padding-block, .65rem)) !important;
    }
    textarea:focus + label {
      transform: scale(.65) translateY(calc(-.4 * var(--input-padding-block, .65rem))) !important;
      opacity: 1 !important;
    }
    button[type="submit"] {
      all: unset;
      width: 192px !important;
      box-sizing: border-box !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      padding: var(--button-padding-block, .875rem) var(--button-padding-inline, 2.5rem) !important;
      background: rgb(var(--button-background-primary)) !important;
      color: rgb(var(--button-text-primary)) !important;
      border-radius: 1.875rem !important;
      font: var(--button-font, inherit) !important;
      letter-spacing: var(--button-letter-spacing, 0) !important;
      text-transform: var(--button-text-transform, none) !important;
      text-align: center !important;
      cursor: pointer !important;
    }
    button[type="submit"]:hover {
      opacity: 0.85 !important;
    }
    form + div {
      display: none !important;
    }
  `;

  function tryInject(el) {
    if (!el || el.dataset.wimInjected) return;
    var formRoot = el.closest('[data-forms-id="' + FORM_ID_ATTR + '"]');
    if (!formRoot) return;
    var sr = el.shadowRoot;
    if (!sr) return;
    if (!sr.querySelector('input, textarea')) return;

    var target = document.querySelector('[id^="wim-forms-target-"]');
    if (target && formRoot.parentElement !== target) {
      formRoot.setAttribute('data-forms-alignment', 'left');
      formRoot.setAttribute('data-forms-text-alignment', 'left');
      target.appendChild(formRoot);
      var appsSection = document.querySelector('.shopify-section--apps');
      if (appsSection) appsSection.style.display = 'none';
    }

    var style = document.createElement('style');
    style.setAttribute('data-wim-inject', 'true');
    style.textContent = SHADOW_CSS;
    sr.appendChild(style);

    el.dataset.wimInjected = '1';
  }

  // WIM-WPO: antes el MutationObserver vigilaba todo el documento en todas las páginas
  // (584-860 ms de CPU en PSI móvil). El formulario solo se recoloca en la página de
  // contacto (sections/contact.liquid pinta el destino wim-forms-target-*), así que solo
  // se arranca allí y se desconecta en cuanto el formulario queda inyectado o a los 15 s.
  if (document.querySelector('[id^="wim-forms-target-"]')) {
    var formsDone = function () {
      var embeds = document.querySelectorAll('shopify-forms-embed');
      for (var k = 0; k < embeds.length; k++) {
        if (embeds[k].dataset.wimInjected) return true;
      }
      return false;
    };

    var scan = function () {
      document.querySelectorAll('shopify-forms-embed').forEach(tryInject);
      if (formsDone()) stop();
    };

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!(node instanceof HTMLElement)) continue;
          if (node.matches && node.matches('shopify-forms-embed')) tryInject(node);
          if (node.querySelectorAll) node.querySelectorAll('shopify-forms-embed').forEach(tryInject);
        }
      }
      if (formsDone()) stop();
    });

    var retries = 0;
    var retryTimer = setInterval(function () {
      scan();
      if (++retries >= 30) stop();
    }, 500);

    var stop = function () {
      observer.disconnect();
      clearInterval(retryTimer);
    };

    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    scan();
  }
  // ./WIM-WPO

  // ── "Ver más" expandable rich text ──────────────────────────────────────

  function initExpandable(wrapper) {
    if (wrapper.dataset.wimExpandInit) return;
    wrapper.dataset.wimExpandInit = '1';

    var visibleCount = parseInt(wrapper.dataset.visible, 10) || 1;
    var moreText = wrapper.dataset.more || 'Ver más';
    var lessText = wrapper.dataset.less || 'Ver menos';

    var content = wrapper.querySelector('.wim-expandable-content');
    if (!content) return;

    var paragraphs = Array.prototype.slice.call(content.children);
    if (paragraphs.length <= visibleCount) return;

    var hidden = document.createElement('div');
    hidden.hidden = true;
    paragraphs.slice(visibleCount).forEach(function (p) {
      hidden.appendChild(p);
    });
    content.appendChild(hidden);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wim-read-more-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = moreText + '<svg class="wim-read-more-icon" viewBox="0 0 10 6" width="10" height="6" aria-hidden="true"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    wrapper.appendChild(btn);

    btn.addEventListener('click', function () {
      var isOpen = !hidden.hidden;
      hidden.hidden = isOpen;
      btn.setAttribute('aria-expanded', String(!isOpen));
      btn.childNodes[0].textContent = isOpen ? moreText : lessText;
    });
  }

  document.querySelectorAll('.wim-expandable-prose').forEach(initExpandable);

  // WIM: el buscador es Doofinder, que se abre al pulsar un campo «q» (el cajón de búsqueda de Shopify
  // está oculto en wim-custom.css). Vale para todos los accesos (lupa móvil, lupa de escritorio y la
  // píldora del rediseño), sin abrir el cajón oculto ni bloquear el scroll. Doofinder se carga diferido
  // (wim-delay-apps): se reintenta hasta que su capa aparece y, si no llega, se va a la página de búsqueda.
  function wimDoofinderOpen() {
    var root = document.querySelector('.dfd-root:not([hidden])');
    return !!(root && root.offsetWidth > 0);
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[aria-controls="search-drawer"]');
    if (!trigger) return;
    var q = document.getElementById('search-drawer-input') || document.querySelector('input[name="q"]');
    if (!q) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var href = trigger.getAttribute('href');
    var tries = 0;
    (function attempt() {
      if (wimDoofinderOpen()) return;
      if (window.doofinderApp || window.DoofinderStarted) q.click();
      if (++tries > 16) { if (!wimDoofinderOpen() && href) window.location.href = href; return; }
      setTimeout(attempt, 250);
    })();
  }, true);

  // ── Custom market redirect ───────────────────────────────────────────────
  // Replaces the native Shopify localization form to force the market language
  // instead of falling back to the browser's preferred language.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-market]');
    if (!btn) return;
    e.preventDefault();

    var market = btn.dataset.market;
    var country = btn.dataset.country;

    var currentPath = window.location.pathname;
    var matched = currentPath.match(/^(\/[a-z]{2}-[a-z]{2})(\/.*)?$/);
    var newPath;

    if (matched) {
      newPath = '/' + market + (matched[2] || '/');
    } else {
      newPath = '/' + market + '/' + currentPath.replace(/^\//, '');
    }

    window.location.href = window.location.origin + newPath + '?country=' + country;
  });
})();

// ── WIM-CRO: asistente "¿Qué talla elijo?" (snippets/wim-size-helper.liquid) ──
(function () {
  'use strict';
  if (window.customElements.get('wim-size-helper')) return;

  // "4 años (99-104 cm)", "11-12 años (137cm-144cm)", "10 años (140 cm)"
  function parseRange(label) {
    var m = label.match(/(\d{2,3})\s*(?:cm)?\s*[-–\/]\s*(\d{2,3})\s*cm/i);
    if (m) return [parseInt(m[1], 10), parseInt(m[2], 10)];
    m = label.match(/(\d{2,3})\s*cm/i);
    if (m) return [parseInt(m[1], 10), parseInt(m[1], 10)];
    return null;
  }

  function fill(tpl, height, size) {
    return tpl.replace(/\{\{\s*height\s*\}\}/g, height).replace(/\{\{\s*size\s*\}\}/g, size);
  }

  class WimSizeHelper extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var data = [];
      try { data = JSON.parse(this.querySelector('.wim-size-helper__data').textContent); } catch (e) { return; }
      this.sizes = data
        .map(function (v) { var r = parseRange(v.label) || (v.range ? parseRange(v.range) : null); return r ? { label: v.label, value: String(v.value), available: v.available, lo: r[0], hi: r[1] } : null; })
        .filter(Boolean)
        .sort(function (a, b) { return a.lo - b.lo || a.hi - b.hi; });
      if (!this.sizes.length) { this.hidden = true; return; }
      var form = this.querySelector('form');
      form.addEventListener('submit', this.onSubmit.bind(this));
      // La ficha vuelve a pintar el selector al cambiar de talla: se restaura el último resultado
      try {
        var last = JSON.parse(sessionStorage.getItem('wim-size-helper') || 'null');
        if (last && last.path === location.pathname && last.name === this.dataset.paramName) {
          this.querySelector('details').open = true;
          this.querySelector('.wim-size-helper__input').value = last.height;
          var o = this.querySelector('.wim-size-helper__result');
          o.textContent = last.msg; if (last.cls) o.classList.add(last.cls);
        }
      } catch (e) {}
    }

    pick(height) {
      var s = this.sizes;
      var inRange = s.filter(function (x) { return height >= x.lo && height <= x.hi; });
      if (inRange.length) return { size: inRange[0], tooTall: false };
      if (height < s[0].lo) return { size: s[0], tooTall: false };
      var bigger = s.filter(function (x) { return x.lo > height; });
      if (bigger.length) return { size: bigger[0], tooTall: false };
      return { size: s[s.length - 1], tooTall: true };
    }

    remember(height, msg, cls) {
      try { sessionStorage.setItem('wim-size-helper', JSON.stringify({ path: location.pathname, name: this.dataset.paramName, height: height, msg: msg, cls: cls })); } catch (e) {}
    }

    onSubmit(event) {
      event.preventDefault();
      var input = this.querySelector('.wim-size-helper__input');
      var out = this.querySelector('.wim-size-helper__result');
      var height = Math.round(parseFloat(String(input.value).replace(',', '.')));
      out.classList.remove('is-ok', 'is-warn');
      if (!height || height < 40 || height > 190) { out.textContent = this.dataset.tInvalid; out.classList.add('is-warn'); return; }

      var res = this.pick(height);
      // WIM rediseño: «Lo llevará con jersey o sudadera debajo» sube una talla
      var layer = this.querySelector('.wim-size-helper__layer-input');
      var layered = false;
      if (layer && layer.checked && !res.tooTall) {
        var i = this.sizes.indexOf(res.size);
        if (i > -1 && i < this.sizes.length - 1) { res = { size: this.sizes[i + 1], tooTall: false }; layered = true; }
        else if (i === this.sizes.length - 1) { layered = 'max'; }
      }
      var size = res.size;
      if (res.tooTall) { out.textContent = fill(this.dataset.tTooTall, height, size.label); out.classList.add('is-warn'); return; }

      var radio = null;
      var name = this.dataset.paramName;
      document.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (r.name === name && r.value === size.value) radio = r;
      });
      if (!size.available || !radio || radio.disabled) {
        out.textContent = fill(this.dataset.tUnavailable, height, size.label) + (layered === 'max' && this.dataset.tLayerMax ? ' ' + this.dataset.tLayerMax : '');
        out.classList.add('is-warn');
        this.remember(height, out.textContent, 'is-warn');
        return;
      }
      var label = radio.id ? document.querySelector('label[for="' + CSS.escape(radio.id) + '"]') : null;
      if (!radio.checked) {
        if (label) { label.click(); } else { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var extra = '';
      if (layered === 'max' && this.dataset.tLayerMax) extra = ' ' + this.dataset.tLayerMax;
      else if (layered && this.dataset.tLayer) extra = ' ' + this.dataset.tLayer;
      out.textContent = fill(this.dataset.tResult, height, size.label) + extra;
      out.classList.add('is-ok');
      this.remember(height, out.textContent, 'is-ok');
    }
  }

  window.customElements.define('wim-size-helper', WimSizeHelper);
})();

